import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';
import {
  BarCharDataAlertChannel,
  LineCharData,
  LineCharDataAlert,
} from '../utils/line_chart_data';
import { PieCharData, PieCharDataAlert } from '../utils/pie_char_data';
import {
  AlertChannel,
  AlertPerWeek,
  AnalystData,
  CasesPerWeek,
  Indicator,
  Indicators,
  IndicatorsAlert,
  IndicatorsTexts,
  IndicatorsTextsAlert,
  TypeCase,
} from '../utils/resume_interfaces';
import { EnvService } from 'src/app/services/env.service';
import { UserService } from 'src/app/core/services/user.service';

interface FilterData {
  units: string;
  cases: string;
  user: string;
}

@Injectable({
  providedIn: 'root',
})
export class ResumeService {
  constructor(
    private readonly http: HttpClient,
    private env: EnvService,
    private userService: UserService
  ) {}

  lastFiveCreated = new Subject<any[]>();
  indicators = new Subject<Indicator[]>();
  lastFiveFinished = new Subject<any[]>();
  lastCasesAssigned = new Subject<any[]>();
  lastCasesRunning = new Subject<any[]>();
  lastCasesTobeApproved = new Subject<any[]>();
  processByAnalyst = new Subject<PieCharData>();
  finishedByAnalyst = new Subject<PieCharData>();
  casesPerWeek = new Subject<LineCharData>();
  LineFinalizedByDate = new Subject<any[]>();
  LineCreatedByDate = new Subject<any[]>();
  BarCasesByCode = new Subject<any[]>();
  typesCases = new Subject<TypeCase[]>();
  statusByAnalyst = new Subject<PieCharData>();
  BarCasesByAnalist = new Subject<any[]>();
  casesPeranAlyst = new Subject<PieCharData>();
  BarCasesFinalizedByAnalist = new Subject<any>();
  casesWithotAssignedBar = new Subject<any[]>();

  filterResumeReport = new Subject<any[]>();
  ////Alertas////
  indicatorsAlert = new Subject<Indicator[]>();
  alertByAnalyst = new Subject<PieCharData>();
  alertByAnalysType = new Subject<PieCharData>();
  alertByAnalysChannel = new Subject<BarCharDataAlertChannel>();
  alertLastFiveRefused = new Subject<any[]>();
  alertLastFiveAssigned = new Subject<any[]>();
  alertLastFiveCreated = new Subject<any[]>();
  alertPerWeek = new Subject<LineCharDataAlert>();

  readonly endPoint = `${this.env.URL_API}/analytics`;
  readonly endPointV1 = `${this.env.URL_API_V1}/analytics`;

  // Procesar toda la data al presioanr el boton procesar en el filtro
  processData(filters: FilterData) {
    this.getLastFiveCreated(filters);
    this.getLastFiveFinished(filters);
    this.getLastFiveAssigned(filters);
    this.getLastFiveRunning(filters);
    this.getLastFiveTobeApproved(filters);

    this.getIndicatorsData(filters);
    this.getProcessByAnalystData(filters);
    this.getFinishedByAnalystData(filters);
    this.getTypecasesData(filters);
    this.getDataPerWeek(filters);
    this.getCasesPeranAlyst(filters);
    this.getLineFinalizedByDate(filters);
    this.getLineCreatedByDate(filters);
    this.getBarCasesByCode(filters);
    this.getBarCasesByAnalist(filters);
    this.getCasesFinalizedByAnalist(filters);
    this.casesWithotAssigned(filters);

    //alertas//
    this.getIndicatorsDataAlert();
    this.alertUsersData(filters);
    this.alertTypeDataType(filters);
    this.typeAlertChannel(filters);
    this.alertLastfiveRefused(filters);
    this.alertLastfiveCrated(filters);
    this.alertLastfiveAssigned(filters);
    this.getAlertDataPerWeek(filters);
  }

  /**
   * Esta funcion busca la data de los ultimos 5 casos creados
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getLastFiveCreated(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/lastfivecreated`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.lastFiveCreated.next(data);
        },
      });
  }

  /**
   * Esta funcion busca la data de los ultimos 5 casos finalizados
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getLastFiveFinished(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/lastfivefinished`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.lastFiveFinished.next(data);
        },
      });
  }
  /**
   * Esta funcion busca la data de los ultimos 5 casos asignados
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getLastFiveAssigned(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/lastCasesAssigned`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.lastCasesAssigned.next(data);
        },
      });
  }

  /**
   * Esta funcion busca la data de los ultimos 5 casos en ejecucion
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getLastFiveRunning(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/lastCasesRunning`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.lastCasesRunning.next(data);
        },
      });
  }
  /**
   * Esta funcion busca la data de los ultimos 5 casos en ejecucion
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getLastFiveTobeApproved(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/lastCasesTobeApproved`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.lastCasesTobeApproved.next(data);
        },
      });
  }

  /**
   * Esta funcion procesa la data de los indicadores
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getIndicatorsData(filters: FilterData) {
    this.http
      .get<Indicators>(`${this.endPointV1}/indicators`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.indicators.next([
            {
              icon: 'assignment',
              value: data.created.value,
              title: IndicatorsTexts.created,
              diff: data.created.diff,
            },
            {
              icon: 'autorenew',
              value: data.process.value,
              title: IndicatorsTexts.process,
              diff: data.process.diff,
            },
            {
              icon: 'check_circle_outline',
              value: data.finished.value,
              title: IndicatorsTexts.finished,
              diff: data.finished.diff,
            },
          ]);
        },
      });
  }
  getProcessByAnalystData(filters: FilterData) {
    this.http
      .get<AnalystData[]>(`${this.endPointV1}/usersData?data=process`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.processByAnalyst.next(new PieCharData(data));
        },
      });
  }
  getFinishedByAnalystData(filters: FilterData) {
    this.http
      .get<AnalystData[]>(`${this.endPointV1}/usersData?data=finished`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.finishedByAnalyst.next(new PieCharData(data));
        },
      });
  }

  getTypecasesData(filters: FilterData) {
    this.http
      .get<TypeCase[]>(`${this.endPointV1}/typecases`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.typesCases.next(data);
        },
      });
  }

  getDataPerWeek(filters: FilterData) {
    this.http
      .get<CasesPerWeek[]>(`${this.endPointV1}/casesperweek`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.casesPerWeek.next(new LineCharData(data));
        },
      });
  }

  //Get by status for resume
  getStatusByAnalystData(filters: FilterData, status) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/byStatusResume?data=${status}`,
      {
        params: filters as any,
      }
    );
    // .subscribe({
    //   next: (data) => {
    //     this.statusByAnalyst.next(new PieCharData(data));
    //   },
    // });
  }

  getTypecasesDataResume(filters: FilterData) {
    return this.http.get<TypeCase[]>(`${this.endPointV1}/typecases`, {
      params: filters as any,
    });
  }

  /**
   * Esta funcion procesa la data de los indicadores
   * TODO: Hacer que la data se actualice cada vez que se cambie el filtro
   */
  getIndicatorsDataResume(filters: FilterData) {
    return this.http.get<Indicators>(`${this.endPointV1}/indicators`, {
      params: filters as any,
    });
  }

  /**
   *
   * casos por estado de aprobacion
   */
  getByApproved(id) {
    return this.http.get<any>(`${this.endPointV1}/getByApproved/${id}`);
  }

  /**
   *
   * casos por nivel de riesgo
   */
  getByLevelRisk(id) {
    return this.http.get<any>(`${this.endPointV1}/getByLevelRisk/${id}`);
  }

  getCasesPeranAlyst(id_unit) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/casesPeranAlyst/${id_unit}`
    );
  }

  getCasesLastWeek(id_unit) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/caseslastweek/${id_unit}`
    );
  }
  getCasesWeeks(id_unit) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/casesweeks/${id_unit}`
    );
  }
  getCasesResumeStatus(id_unit) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/casesresumestatus/${id_unit}`
    );
  }

  //Casos finalizados por fecha LineChart

  getLineFinalizedByDate(filters) {
    return this.http
      .get<any[]>(`${this.endPointV1}/getLineFinalizedByDate`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.LineFinalizedByDate.next(data);
        },
      });
  }

  getLineCreatedByDate(filters) {
    return this.http
      .get<any[]>(`${this.endPointV1}/getLineCreatedByDate`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.LineCreatedByDate.next(data);
        },
      });
  }
  getBarCasesByCode(filters) {
    return this.http
      .get<any[]>(`${this.endPointV1}/getBarCasesByCode`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.BarCasesByCode.next(data);
        },
      });
  }

  getBarCasesByAnalist(filters) {
    return this.http
      .get<any[]>(`${this.endPointV1}/getBarCasesByAnalist`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.BarCasesByAnalist.next(data);
        },
      });
  }
  getCasesFinalizedByAnalist(filters) {
    return this.http
      .get<any[]>(`${this.endPointV1}/getCasesFinalizedByAnalist`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.BarCasesFinalizedByAnalist.next(data);
        },
      });
  }
  casesWithotAssigned(filters) {
    return this.http
      .get<any[]>(`${this.endPointV1}/casesWithotAssigned`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.casesWithotAssignedBar.next(data);
        },
      });
  }
  /////
  // informe Productividad
  generalReportResumen(filters) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/generalReportResumen`,
      { params: filters }
    );
  }

  unitReportResumen(filters) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/unitReportResumen`,
      { params: filters }
    );
  }
  caseTypeReportResumen(filters) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/caseTypeReportResumen`,
      { params: filters }
    );
  }
  userCaseReportResumen(filters) {
    return this.http.get<AnalystData[]>(
      `${this.endPointV1}/userCaseReportResumen`,
      { params: filters }
    );
  }

  //////////////////////
  ///////Alertas////////
  /////////////////////

  getIndicatorsDataAlert() {
    this.http
      .get<IndicatorsAlert>(`${this.endPointV1}/alertIndicator`)
      .subscribe({
        next: (data) => {
          this.indicatorsAlert.next([
            {
              icon: 'assignment',
              value: data.created.value,
              title: IndicatorsTextsAlert.created,
              diff: data.created.diff,
            },
            {
              icon: 'autorenew',
              value: data.process.value,
              title: IndicatorsTextsAlert.process,
              diff: data.process.diff,
            },
            {
              icon: 'clear',
              value: data.refused.value,
              title: IndicatorsTextsAlert.refused,
              diff: data.refused.diff,
            },
          ]);
        },
      });
  }
  alertUsersData(filters: FilterData) {
    this.http
      .get<AnalystData[]>(`${this.endPointV1}/alertUsersData`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.alertByAnalyst.next(new PieCharData(data));
        },
      });
  }
  alertTypeDataType(filters: FilterData) {
    this.http
      .get<AnalystData[]>(`${this.endPointV1}/alertTypeDataType`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.alertByAnalysType.next(new PieCharDataAlert(data));
        },
      });
  }
  typeAlertChannel(filters) {
    return this.http.get<AlertChannel>(`${this.endPointV1}/alertChannel`, {
      params: filters as any,
    });
    // .subscribe({
    //   next: (data) => {
    //     this.alertByAnalysChannel.next(new BarCharDataAlertChannel(data));
    //   },
    // });
  }

  /**
   * Esta funcion busca la data de los ultimas alertas rechazados
   *
   */ alertLastfiveRefused(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/alertLastfiveRefused`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.alertLastFiveRefused.next(data);
        },
      });
  }

  /**
   * Esta funcion busca la data de los ultimas alertas asignadas
   *
   */ alertLastfiveAssigned(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/alertLastfiveAssigned`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.alertLastFiveAssigned.next(data);
        },
      });
  }

  /**
   * Esta funcion busca la data de los ultimas alertas creadas
   *
   */ alertLastfiveCrated(filters: FilterData) {
    this.http
      .get<ICase[]>(`${this.endPointV1}/alertLastfiveCrated`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.alertLastFiveCreated.next(data);
        },
      });
  }

  /**
   * Esta funcion busca la data por semana de alertas
   *
   */
  getAlertDataPerWeek(filters: FilterData) {
    this.http
      .get<AlertPerWeek[]>(`${this.endPointV1}/alertsperweek`, {
        params: filters as any,
      })
      .subscribe({
        next: (data) => {
          this.alertPerWeek.next(new LineCharDataAlert(data));
        },
      });
  }
  ///////////////////////////
  /////Alertas Dashboard/////
  ///////////////////////////
  /**
   * Esta funcion busca la data de las mini cards de alertas
   *
   */
  getDataMiniCards(filters = { user: this.userService.currentUser._id }) {
    return this.http.get<any[]>(`${this.endPointV1}/alertsMiniCards`, {
      params: filters as any,
    });
  }

  /**
   * Esta funcion busca la data de las progrebars de alertas por estado
   *
   */
  getDataBarStatusAlert(filters = { user: this.userService.currentUser._id }) {
    return this.http.get<any[]>(`${this.endPointV1}/getDataBarStatusAlert`, {
      params: filters as any,
    });
  }

  /**
   * Esta funcion busca la data de alertas creados y cerrados
   *
   */
  getDataAlertCreatedClosed(
    filters = { user: this.userService.currentUser._id }
  ) {
    return this.http.get<any[]>(
      `${this.endPointV1}/getDataAlertCreatedClosed`,
      {
        params: filters as any,
      }
    );
  }

  /**
   * Esta funcion busca la data de alertas por prioridad
   *
   */
  getDataProgressPriorityAlert(
    filters = { user: this.userService.currentUser._id }
  ) {
    return this.http.get<any[]>(
      `${this.endPointV1}/getDataProgressPriorityAlert`,
      {
        params: filters as any,
      }
    );
  }
  /**
   * Esta funcion busca strikes por alertas con mas strikes
   *
   */
  getDataStrikeByAlert(filters = { user: this.userService.currentUser._id }) {
    return this.http.get<any[]>(`${this.endPointV1}/getDataStrikeByAlert`, {
      params: filters as any,
    });
  }

  /**
   * Esta funcion busca la data de alertas de asignados vs resueltos por analistas
   *
   */
  getDataAssignedVsResolved(
    filters = { user: this.userService.currentUser._id }
  ) {
    return this.http.get<any[]>(
      `${this.endPointV1}/getDataAssignedVsResolved`,
      {
        params: filters as any,
      }
    );
  }

  /**
   * Esta funcion busca la data de alertas reasignadas
   *
   */
  getDataBarReasingned(filters = { user: this.userService.currentUser._id }) {
    return this.http.get<any[]>(`${this.endPointV1}/getDataBarReasingned`, {
      params: filters as any,
    });
  }

  /**
   * Esta funcion busca la data de alertas porcentaje tiempo de respuesta
   *
   */
  getAverageResponseTime(filters = { user: this.userService.currentUser._id }) {
    return this.http.get<any[]>(`${this.endPointV1}/getAverageResponseTime`, {
      params: filters as any,
    });
  }

  /**
   * Esta funcion busca la data de alertas porcentaje tiempo de Resolucion
   *
   */
  getAverageResolutionTime(
    filters = { user: this.userService.currentUser._id }
  ) {
    return this.http.get<any[]>(`${this.endPointV1}/getAverageResolutionTime`, {
      params: filters as any,
    });
  }
}
